/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Form_QuoteInputs */

const vi_carrier_form_quote = /** @type {(inputs: Carrier_Form_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lấy báo giá`)
};

/**

* @param {Carrier_Form_QuoteInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_form_quote = /** @type {((inputs?: Carrier_Form_QuoteInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Form_QuoteInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_form_quote(inputs)
});